import { Reducer } from 'redux'
import { ActionTypes, ROUTE_ACTIONS, User } from './types'

export type StateFlippers = {
  isUsingFiatCurrency: boolean
}

export type State = StateFlippers & {
  user: User
  isUserInfoInitialised: boolean
  isUserInfoFromSsoInitialised: boolean
}

// TODO(benedictkhoo): remove after all domain stores are successfully migrated to common store
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const route: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case ROUTE_ACTIONS.SET_ACKNOWLEDGE_TRANSFER_DISCLAIMER:
      return {
        ...state,
        user: {
          ...state.user,
          isStablecoinTransferDisclaimerAcknowledged: true,
        },
      }
    case ROUTE_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }
    case ROUTE_ACTIONS.SET_USER_KC_ID: {
      return {
        ...state,
        user: {
          ...state.user,
          kcId: action.kcId,
        },
      }
    }
    case ROUTE_ACTIONS.SET_USER_BIZ_ID: {
      return {
        ...state,
        user: {
          ...state.user,
          bizId: action.bizId,
        },
      }
    }
    default:
      return state
  }
}
